import { apiEndPoint } from 'config';

export const apiConstants = {
  login: `${apiEndPoint.apiUrl}/account/login`,
  register: `${apiEndPoint.apiUrl}/account/register`,
  updatePassword: `${apiEndPoint.apiUrl}/account/password_update`,
  forgotPassword: `${apiEndPoint.apiUrl}/account/forgotpassword/:email`,
  resetPassword: `${apiEndPoint.apiUrl}/account/activate/:token`,
  checkToken: `${apiEndPoint.apiUrl}/account/token_verification/:token`,

  getLoggedAccountPermissions: `${apiEndPoint.apiUrl}/permissions/my_permissions`,
  getAccountType: `${apiEndPoint.apiUrl}/account/types/:account_type_id`,
  getAccountTypes: `${apiEndPoint.apiUrl}/account/types/`,
  getCustomerAccountTypes: `${apiEndPoint.apiUrl}/customer/account/types/`,

  addInterimAccount: `${apiEndPoint.apiUrl}/account/signup`,
  addCustomerAccount: `${apiEndPoint.apiUrl}/customer/account/signup`,

  getProfile: `${apiEndPoint.apiUrl}/account/profile`,
  updateProfile: `${apiEndPoint.apiUrl}/account/profile`,

  getAllAccounts: `${apiEndPoint.apiUrl}/accounts/`,
  getAccount: `${apiEndPoint.apiUrl}/accounts/:account_id`,
  putAccount: `${apiEndPoint.apiUrl}/accounts/:account_id`,
  deleteAccount: `${apiEndPoint.apiUrl}/accounts/:account_id`,
  deleteOwnAccount: `${apiEndPoint.apiUrl}/accounts/`,


  getInterimAccount: `${apiEndPoint.apiUrl}/accounts/:account_id/`,
  getCustomerAccount: `${apiEndPoint.apiUrl}/customers/accounts/:account_id/`,

  addCustomer: `${apiEndPoint.apiUrl}/customers`,
  addBulkCustomers: `${apiEndPoint.apiUrl}/customers/bulk`,
  getCustomer: `${apiEndPoint.apiUrl}/customers/:customer_id`,
  getCustomers: `${apiEndPoint.apiUrl}/customers/`,
  updateCustomer: `${apiEndPoint.apiUrl}/customers/:customer_id`,
  deleteCustomer: `${apiEndPoint.apiUrl}/customers/:customer_id`,

  getPCCWGlobalAccounts: `${apiEndPoint.apiUrl}/users/pccwglobal/pccwglobal`,
  getCustomerAccounts: `${apiEndPoint.apiUrl}/customer/accounts/`,

  getCountry: `${apiEndPoint.apiUrl}/countries/:country_id`,
  getCountries: `${apiEndPoint.apiUrl}/countries/`,

  getCurrency: `${apiEndPoint.apiUrl}/currencies/:currency_id`,
  getCurrencies: `${apiEndPoint.apiUrl}/currencies`,

  getCity: `${apiEndPoint.apiUrl}/cities/:city_id`,
  getCities: `${apiEndPoint.apiUrl}/cities`,

  getCountryCodes: `${apiEndPoint.apiUrl}/country_dial_codes`,

  getServiceNumberTypes: `${apiEndPoint.apiUrl}/servicenumbers/type`,
  getServiceNumberTypeCoverage: `${apiEndPoint.apiUrl}/servicenumbers/type/coverage`,
  getServiceNumberTypeCoverageCoordinates: `${apiEndPoint.apiUrl}/servicenumbers/type/coverage/coordinates`,

  getServiceNumberTypeCoverageCities: `${apiEndPoint.apiUrl}/servicenumbers/type/coverage/cities`,
  addBulkServiceNumberTypes: `${apiEndPoint.apiUrl}/servicenumbers/type/bulk`,
  addServiceNumberTypes: `${apiEndPoint.apiUrl}/servicenumbers/type`,
  getServiceNumberType: `${apiEndPoint.apiUrl}/servicenumbers/type/:service_number_type_id`,
  putServiceNumberType: `${apiEndPoint.apiUrl}/servicenumbers/type/:service_number_type_id`,

  getAllDnis: `${apiEndPoint.apiUrl}/dnis/`,
  putDnis: `${apiEndPoint.apiUrl}/dnis/:dnis_id`,


  getAllPricing: `${apiEndPoint.apiUrl}/tariff/`,
  getPricing: `${apiEndPoint.apiUrl}/tariff/:tariff_id`,

  addVendor: `${apiEndPoint.apiUrl}/vendors`,
  addBulkVendors: `${apiEndPoint.apiUrl}/vendors/bulk`,
  getVendor: `${apiEndPoint.apiUrl}/vendors/:vendor_id`,
  getVendors: `${apiEndPoint.apiUrl}/vendors/`,
  updateVendor: `${apiEndPoint.apiUrl}/vendors/:vendor_id`,
  deleteVendor: `${apiEndPoint.apiUrl}/vendors/:vendor_id`,



  addOrder: `${apiEndPoint.apiUrl}/orders`,
  getOrder: `${apiEndPoint.apiUrl}/orders/:order_id`,
  updateOrder: `${apiEndPoint.apiUrl}/orders/:order_id`,
  getAllOrder: `${apiEndPoint.apiUrl}/orders`,


  getFunctionalities: `${apiEndPoint.apiUrl}/functionalities`,

  getNotification: `${apiEndPoint.apiUrl}/notifications/:notification_id`,
  getNotifications: `${apiEndPoint.apiUrl}/notifications`,
  addNotifications: `${apiEndPoint.apiUrl}/notifications`,

  getNotificationType: `${apiEndPoint.apiUrl}/notifications/type/:notification_type_id`,
  getNotificationTypes: `${apiEndPoint.apiUrl}/notifications/type/`,
  updateNotificationType: `${apiEndPoint.apiUrl}/notifications/type/:notification_type_id`,

  getPermissions: `${apiEndPoint.apiUrl}/permissions`,
  addPermission: `${apiEndPoint.apiUrl}/permissions`,
  getPermission: `${apiEndPoint.apiUrl}/permissions/:permission_id`,
  updatePermission: `${apiEndPoint.apiUrl}/permissions/:permission_id`,
  deletePermission: `${apiEndPoint.apiUrl}/permissions/:permission_id`,

  uploadDocument: `${apiEndPoint.apiUrl}/documents`,
  uploadOrderDocument: `${apiEndPoint.apiUrl}/documents/order/:customer_id/:order_id/:input_id`,
  downloadOrderDocument: `${apiEndPoint.apiUrl}/documents/order/:customer_id/:order_id/:filename`,
  downloadDocument: `${apiEndPoint.apiUrl}/documents/:filename`,
  getTemplateExcel: `${apiEndPoint.apiUrl}/templates/:template`,

  getReport: `${apiEndPoint.apiUrl}/reports/:category/:report_name`,
  getAllConfigurations: `${apiEndPoint.apiUrl}/configuration`,
  updateConfigurations: `${apiEndPoint.apiUrl}/configuration`,

  getInvNumbers: `${apiEndPoint.apiUrl}/invnumbers`,
  addInvNumber: `${apiEndPoint.apiUrl}/invnumbers`,
  getInvNumberJurisdictions: `${apiEndPoint.apiUrl}/invnumbers/jurisdictions`,

  getCarriers: `${apiEndPoint.apiUrl}/carriers`,
  addCarrier: `${apiEndPoint.apiUrl}/carriers`,

  addBulkCarrier: `${apiEndPoint.apiUrl}/carriers/bulk`,


  getInvNumberCities: `${apiEndPoint.apiUrl}/invnumbers/cities`,
  getInvNumber: `${apiEndPoint.apiUrl}/invnumbers/:invnumber_id`,

  addBulkInvNumber: `${apiEndPoint.apiUrl}/invnumbers/bulk`,

  getCalls: `${apiEndPoint.apiUrl}/calls`,
  getCallJurisdictions: `${apiEndPoint.apiUrl}/calls/jurisdictions`,

  getCallCities: `${apiEndPoint.apiUrl}/calls/cities`,


  addFileDownload: `${apiEndPoint.apiUrl}/reports/download/:category/:report_name`,
  getFilesDownload: `${apiEndPoint.apiUrl}/downloads`,
  getFileDownload: `${apiEndPoint.apiUrl}/download/:report_name`,
};
